
<template>
  <div>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title"> {{$t('coupons.title_info')}} </h4>
      </div>
      <div class="modal-body">
        <!-- full_name -->
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`coupons.code`)}}</label>
              <input type="text" class="form-control" :placeholder="$t('coupons.code')" v-model="coupon.code" id="code" disabled >
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`coupons.name`)}}</label>
              <input type="text" class="form-control" :placeholder="$t('coupons.name')" v-model="coupon.name" id="name" >
              <span v-if="(coupon.name == '' || coupon.name == null) && nameValidate == true" class="help is-danger">
                <font color="red">{{$t('coupons.required_field')}}</font>
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`coupons.expires_at`)}}</label>
              <date-picker class="form-control" v-model="coupon.expires_at" :config="options" id="expires_at"></date-picker>
              <span v-if="(coupon.expires_at == '' || coupon.expires_at == null) && expires_atValidate == true" class="help is-danger">
                <font color="red">{{$t('coupons.required_field')}}</font>
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`coupons.discount_type`)}}</label>
              <select v-model="coupon.coupon_type_code" class="form-control">
                <option
                    v-for="coupon_type_code in coupon_type_code_list"
                    v-bind:value="coupon_type_code.id"
                    :key="coupon_type_code.id"
                >{{ $t(coupon_type_code.text) }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`coupons.discount`)}}</label>
              <input type="text" class="form-control" :placeholder="$t('coupons.discount')" v-model="coupon.discount" id="discount" >
              <span v-if="(coupon.discount == '' || coupon.discount == null)" class="help is-danger">
                <font v-if="discountValidate == true" color="red">{{$t('coupons.required_field')}}</font>
              </span>
              <span v-else class="help is-danger">
                <font v-if="discountValidateFormat == true" color="red">{{$t('coupons.discount_field')}}</font>
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`coupons.status`)}}</label>
              <select v-model="coupon.status" class="form-control">
                <option
                    v-for="status in service_coupon_status_list"
                    v-bind:value="status.id"
                    :key="status.id"
                >{{ $t(status.text) }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>{{$t(`coupons.number_coupons`)}}</label>
              <input type="text" class="form-control" :placeholder="$t('coupons.number_coupons')" v-model="coupon.number_coupons" id="number_coupons" >
              <span v-if="(coupon.number_coupons == '' || coupon.number_coupons == null)" class="help is-danger">
                <font v-if="number_couponsValidate == true" color="red">{{$t('coupons.required_field')}}</font>
              </span>
              <span v-else class="help is-danger">
                <font v-if="number_couponsValidateFormat == true" color="red">{{$t('coupons.discount_field')}}</font>
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>{{$t(`coupons.notes`)}}</label>
              <textarea type="text" class="form-control" :placeholder="$t('coupons.notes')" v-model="coupon.notes">
              </textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          style="background-color: #f29911;border-color: #f29911;color:#fff"
          type="button"
          class="btn btn-default pull-left"
          data-dismiss="modal"
        >{{$t('common.back')}}</button>
        <button
          type="button"
          class="btn btn-primary"
          v-if="!!id"
          @click="onSave"
        >{{$t('common.save')}}</button>
        <button
          type="button"
          class="btn btn-primary"
          v-else
          @click="onAdd"
        >{{$t('common.add')}}</button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex"
import constantsData from '@/lib/constantsData'
import datePicker from "vue-bootstrap-datetimepicker";
import utils from "@/lib/utils";
// import Loading from "vue-loading-overlay"
// import i18n from '../../lang'

export default {
  name: "ServiceCouponsModalInput",
  props: {
    id: {
      type: Number,
      default: () => { return 0 }
    },
  },
  data() {
    return {
      coupon_type_code_list: constantsData.discountTypeCode,
      service_coupon_status_list: constantsData.serviceCouponStatus,
      coupon: {
        code: null,
        name: null,
        notes: null,
        discount: "",
        coupon_type_code: "cash", // cash, perc
        number_coupons: 1,
        expires_at: new Date(),
        status: 1, // serviceCouponStatus
      },
      field_required:{
        'full_name':'',
        'relationship':''
      },
      nameValidate:false,
      discountValidate:false,
      expires_atValidate:false,
      discountValidateFormat: false,
      number_couponsValidateFormat: false,
      number_couponsValidate:false,
      options: {
        format: "DD-MM-YYYY"
      }
    }
  },
  watch: {
    id: function() {
      if (this.id !== 0) {
        this.GET_COUPON_DETAIL({id:this.id}).then(
          function(res) {
            let data = res
            let expires_at = utils.formatSqlDate(data.expires_at, null, constantsData.dateOptionList[0].format, "");
            this.coupon.code = data.code
            this.coupon.name = data.name
            this.coupon.notes = data.notes
            this.coupon.number_coupons = data.number_coupons
            this.coupon.discount = data.coupon_type_code == 'cash' ? data.discount_amount : data.discount_percentage
            this.coupon.coupon_type_code = data.coupon_type_code
            this.coupon.expires_at = expires_at
            this.coupon.status = data.status
          }.bind(this)
        )
      } else {
        this.reset()
      }
    }
  },
  computed: {
    ...mapGetters([])
  },
  methods: {
    ...mapActions([
      "GET_CODE_COUPON", "GET_COUPON_DETAIL", "ON_SHOW_TOAST"
    ]),
    reset: function() {
      this.get_code();
      this.coupon.name = ""
      this.coupon.notes = ""
      this.coupon.discount = 0
      this.coupon.coupon_type_code = 'cash'
      this.coupon.number_coupons = 1
      this.coupon.expires_at = new Date()
      this.coupon.status = 1
    },
    onAdd: function() {
      if(this.coupon.name === null || this.coupon.name === ""){
        this.nameValidate=true
      }
      else if(this.coupon.discount === null || this.coupon.discount === ""){
        this.discountValidate=true
      } else if(this.coupon.expires_at === null || this.coupon.expires_at === ""){
        this.expires_atValidate=true
      } else if(this.coupon.number_coupons === null || this.coupon.number_coupons === ""){
        this.number_couponsValidate=true
      }
      else
      {
        let val = parseFloat(this.coupon.discount);
        if(isNaN(val)){
          this.discountValidateFormat = true
          return;
        }

        val = parseInt(this.coupon.number_coupons);
        if(isNaN(val) || this.coupon.number_coupons <= 0){
          this.number_couponsValidateFormat = true
          return;
        }
        // discount_amount = discount_percentage
        // coupon_type_code will display with discount_amount/discount_percentage
        const data = {
        code: this.coupon.code,
        name: this.coupon.name,
        notes: this.coupon.notes,
        number_coupons: this.coupon.number_coupons,
        discount_amount: this.coupon.discount,
        discount_percentage: this.coupon.discount,
        coupon_type_code: this.coupon.coupon_type_code,
        // save with format YYYY-MM-DD
        expires_at: utils.formatSqlDate(this.coupon.expires_at, "DD-MM-YYYY", "YYYY-MM-DDThh:mm"), 
        status: this.coupon.status
      }
      this.$emit("coupon-add", data)
      }
    },
    onSave: function() {
      if(this.coupon.name === null || this.coupon.name === ""){
        this.nameValidate=true
      }
      else if(this.coupon.discount === null || this.coupon.discount === ""){
        this.discountValidate=true
      } else if(this.coupon.expires_at === null || this.coupon.expires_at === ""){
        this.expires_atValidate=true
      } else if(this.coupon.number_coupons === null || this.coupon.number_coupons === ""){
        this.number_couponsValidate=true
      }
      else
      {
        const id = this.id
        let val = parseFloat(this.coupon.discount);
        if(isNaN(val)){
          this.discountValidateFormat = true
          return;
        }

        val = parseInt(this.coupon.number_coupons);
        if(isNaN(val) || this.coupon.number_coupons <= 0){
          this.number_couponsValidateFormat = true
          return;
        }

        const data = {
          code: this.coupon.code,
          name: this.coupon.name,
          notes: this.coupon.notes,
          discount_amount: this.coupon.discount,
          discount_percentage: this.coupon.discount,
          coupon_type_code: this.coupon.coupon_type_code,
          // save with format YYYY-MM-DD
          expires_at: utils.formatSqlDate(this.coupon.expires_at, "DD-MM-YYYY", "YYYY-MM-DDThh:mm"), 
          status: this.coupon.status
        }
        this.$emit("coupon-save", id, data)
        }
    },

    validateFieldIsEmpty: function(field, objectName = 'this.relative.',  objectNameRequire = 'this.field_required.' ) {

            // use for get value : this.userdata.last_name
            let exec = objectName + field

            // this.field_required.last_name
            let error_msg = objectNameRequire + field

            // Init data befor check
            eval(error_msg + " = ''")

            // ==> get value current
            let result = eval(exec)

            if (result == null || result == "") {
                eval(error_msg + " = 'common.error_msg[0].required'")
            }

            return result;
    },     
    get_code: function(){
      this.GET_CODE_COUPON().then(
      function(res) {
        let data = res.data
        this.coupon.code = data.message
      }.bind(this)
    )
    } 
  },
  mounted() {
    this.get_code();
  },
  components: {
      "date-picker": datePicker,
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Service/ServiceCouponsModalInput.vue